import { linkTo } from '@99designs/routing';
import type { ZendeskLanguage } from '@99designs/routing';
import type { CollaborationMethod } from '../../types';

export type CollaborationContent = {
    title: string;
    description: string;
    inclusions: string[];
    link: {
        href: string;
    };
};

export const collaborationMethods = (
    method: CollaborationMethod,
    lang?: ZendeskLanguage
): CollaborationContent => {
    const collaborationMethods: Record<CollaborationMethod, CollaborationContent> = {
        COLLABORATION_METHOD_CONTEST: {
            title: __('Contest'),
            description: __(
                'Open your design brief to our entire community. Designers submit their ideas and you pick your favorite design.'
            ),
            inclusions: [
                __('Creative concepts from multiple designers'),
                __('Choose a winning design and receive copyright to the files'),
            ],
            link: {
                href: linkTo.howItWorks(),
            },
        },
        COLLABORATION_METHOD_CONTEST_BUNDLE: {
            title: __('Contest Bundle'),
            description: __(
                'Open your design brief to our entire community. Designers submit their ideas and you pick your favorite design.'
            ),
            inclusions: [
                __('Creative concepts from multiple designers'),
                __('Choose a winning design and receive copyright to the files'),
                __('Work with the winning designer to finalize deliverables in your bundle'),
            ],
            link: {
                href: linkTo.howItWorks(),
            },
        },
        COLLABORATION_METHOD_ONE_TO_ONE_PROJECT: {
            title: __('1-to-1 project'),
            description: __(
                "Tell us about your design needs and we'll match you with designers that are best suited to the job"
            ),
            inclusions: [
                __('Designers express interest in your project'),
                __('View portfolios and choose a designer to work with'),
                __('Collaborate on your design'),
            ],
            link: {
                href: linkTo.supportUrl('8934876076692', 'articles', lang || 'en'),
            },
        },
        COLLABORATION_METHOD_STUDIO: {
            title: __('Studio'),
            description: __(
                "We'll match you with a Creative Director to craft a strategic brand that translates your business goals into a visual identity."
            ),
            inclusions: [
                __(
                    'Start with a discovery session with your Creative Director to discuss your product, positioning and audience.'
                ),
                __('Receive 3 brand concepts including the thought process behind each.'),
                __(
                    'Your Studio Project Manager will guide you throughout the project and answer any questions.'
                ),
            ],
            link: {
                href: linkTo.studio(),
            },
        },
    };
    return collaborationMethods[method];
};
